import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router } from '@angular/router';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
// services
import { LoginService } from '../../services/login.service';
import { DataStorageService } from '../../services/data-storage.service';
import { CopyService } from '../../../shared/services/app-copy.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
// globals
import { EMAIL_PATTERN } from '../../../shared/globals';

declare var exponea: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [
    DataStorageService
  ]
})
export class LoginComponent implements OnInit, OnDestroy {

  private _userSubscription: Subscription;
  private _tokenSubscription: Subscription;
  private _dataLoadedSubscription: Subscription;
  private _userStoreSubscription: Subscription;
  private _userLanguageSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _emailSentSubscription: Subscription;

  private _userRedirect: any;

  public parentRoute = '';
  public showLoader: Boolean = false;
  public emailPattern = EMAIL_PATTERN;
  public userEmail: string;
  public rememberMe: boolean = true;
  public appCopy;
  public copyLoaded: Boolean = false;
  public selectedLanguage = '';
  public showPassword:boolean = false;

  constructor(
    private _appStore: Store<AppState>,
    private _loginService: LoginService,
    private _router: Router,
    private _dataStorage: DataStorageService,
    private _copyService: CopyService,
    private _errorService: ErrorHandler,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {

    this._userLanguageSubscription = this._appStore.select('copyReducer')
    .subscribe((res: any) => {
    this.selectedLanguage = res.language
    })


    if (isPlatformBrowser(this.platformId)) {

      this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
        .subscribe((res: any) => {
          this.copyLoaded = res.copyLoaded;
            if (res.copyLoaded) {
              this.getCopy();
            }

        })
      // get url - check if login is in modal
      const urlFrag = window.location.pathname.split('/');
      const urlFragLength = (urlFrag.length) - 1;
      this.parentRoute = urlFrag[urlFragLength];
    }

    this._userStoreSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {
        this.userEmail = user.userDetails.userEmail;
        this._userRedirect = user.userDetails.redirect;
      });

    this._tokenSubscription = this._loginService.tokenSubject$
      .subscribe(token => {
        if (token.error) {
          this.handleErrors();
          this.showLoader = false;
        }
      },
        err => console.log(err));

    this._userSubscription = this._loginService.userSubject$
      .subscribe(user => {

        if (user.error) {
          this.handleErrors();
        }

        if (this.parentRoute === 'payment') {

          if (isPlatformBrowser(this.platformId)) {
            // login in modal
            this.showLoader = false;
            // this._modalComponent.closeModal();
            const btn = document.getElementById('login-modal-close');
            btn.click();
            return;
          }

        } else {
          // handle other login flows
          this._dataStorage.saveData();

          this._dataLoadedSubscription = this._dataStorage.dataSaved$
            .subscribe(dataLoaded => {

              if (this._userRedirect.path === '') {
                this._router.navigate(['my-account/home']);
              } else {
                this._router.navigate([this._userRedirect.path],
                  { queryParams: { ref: this._userRedirect.ref } });
              }

              this._dataLoadedSubscription.unsubscribe();
              this.showLoader = false;
            });

        }

      },
        err => console.log(err));


      this._emailSentSubscription = this._loginService.forgotPasswordEmailSent$
        .subscribe(emailSent => {
          this.showLoader = false;

          if (emailSent.error) {
            this.handleErrors();
            return;
          }

          if (emailSent) {

            const data = {
              text: 'OTP sent to Email!',
              type: 'info',
              icon: 'alert',
              sticky: false
            };

            if (this.getState(this._appStore).userReducer.userDetails.is2FARequired) {
              data.text = 'OTP sent to phone number!';
            }
            this._errorService.handleCustomInfo(data);
          }
        },
          err => console.log(err));
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'login',
      ['completeloginScreen']
    );
    console.log(panelHeaderCopy)
    this.appCopy = {
      panelHeader: panelHeaderCopy[0],
    };

  }

  handleErrors() {
    this.showLoader = false;
  }

  handleLogin(value: { Username: string; Password: string; rememberMe: any; }, e: Event) {
    e.preventDefault();
    const encodedPassword = encodeURIComponent(value.Password);
    const params = 'grant_type=password&username=' + encodeURIComponent(value.Username) + '&password=' + encodedPassword;
    const storeCookie = value.rememberMe !== '' ? value.rememberMe : false;
    const isGuest = false;

    this.showLoader = true;

    this._loginService.getToken(params, storeCookie, isGuest, value.Username, 'mmb_login');
    this._loginService.userHasPassword();

    exponea.identify({ 'email_id': value.Username });
    exponea.track('mmb_login', {
      login_type: 'password',
    });
  }

  goToRegister() {
    this._router.navigate(['register']);
  }

  goToForgotPassword() {
    this._router.navigate(['forgot-password']);
  }

  getState(appStore: Store<AppState>) {
    let state: AppState;
    appStore.subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._userStoreSubscription.unsubscribe();
    this._userSubscription.unsubscribe();
    this._tokenSubscription.unsubscribe();
    if (this._emailSentSubscription) {
      this._emailSentSubscription.unsubscribe();
    }
  }

}
